import type { FaireProductEntity } from "../../entity_types/product";

export const p_uvau94bejh: FaireProductEntity = {
  token: "p_uvau94bejh",
  type: "product",
  name: "Mascarilla de Guava",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/757f10b05431c08aee25c95c519ab1e0d14f2d4445cbfd13d0e87ad8e27df623.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 18,
  description: "Mascarilla de Guava for wholesale.",
  tags: ["haircare"],
  caseSize: 1,
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
